import { format, isValid, parse, parseISO, endOfMonth } from 'date-fns';
import { zhCN } from 'date-fns/locale';

const DATE_INPUT_PATTERN = 'yyyy-MM-dd';
const LOCALE = { locale: zhCN } as const;

/** Budget months are plain `yyyy-MM` strings, like loot-core's `month`. */
export function currentMonth(now = new Date()): string {
  return format(now, 'yyyy-MM');
}

export function yearFromMonth(month: string): number {
  return Number(month.slice(0, 4));
}

export function addMonthLength(month: string, length: number): string {
  const [year, mon] = month.split('-').map(Number);
  const index = year * 12 + (mon - 1) + length;
  return `${String(Math.floor(index / 12)).padStart(4, '0')}-${String(
    (index % 12) + 1,
  ).padStart(2, '0')}`;
}

export function longFromMonth(month: string): string {
  return format(parseISO(`${month}-01`), 'MMMM', LOCALE);
}

export function shortFromMonth(month: string): string {
  return format(parseISO(`${month}-01`), 'MMM', LOCALE);
}

export function monthRange(start: string, end: string): string[] {
  const months: string[] = [];
  let cursor = start;
  while (cursor <= end) {
    months.push(cursor);
    cursor = addMonthLength(cursor, 1);
  }
  return months;
}

/** Transaction dates are `yyyy-MM-dd`; the UI renders them per locale. */
export function formatDate(
  date: string | Date | null | undefined,
  pattern = 'yyyy-MM-dd',
): string {
  if (!date) return '';
  const parsed =
    typeof date === 'string'
      ? parse(date, DATE_INPUT_PATTERN, new Date())
      : date;
  return isValid(parsed) ? format(parsed, pattern, LOCALE) : '';
}

export function lastDayOfMonth(month: string): Date {
  return endOfMonth(parseISO(`${month}-01`));
}
